export default {
    'diagram1-3a1': {
        'diagram-number': 'Example',
        'elements': {
            'one': 'Physical laws dictate that an <span>organism’s</span> every action is the result of previous events',
            'two': '<span>Human beings are organisms</span>, and consequently subject to those laws',
            'three': 'Thus, human behaviour must result from a complete sequence of causes and effects that is completely out of our control',
        }
    }
}


// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a1/diagram1/i18n/en.js